export const testimonialObj1 = {
  pic_url:
    "https://media-exp1.licdn.com/dms/image/C5603AQHXPdNdH4VYtQ/profile-displayphoto-shrink_100_100/0/1517674073344?e=1630540800&v=beta&t=oDWV2EXILUM6MnZtwJ_9_EdtyKzP0p7BBHA1BA04wEY",
  profile_url: "https://www.linkedin.com/in/rowlybourne/",
  name: "Rowly Bourne",
  description: "Head of UK&I VC&C Partnerships at Facebook",
  praise:
    "Marc is an incredible networker! Hosting several virtual networking groups, he has a good understanding of what he member is looking for. Above all, he keeps the groups energised and on topic.",
};

export const testimonialObj2 = {
  pic_url:
    "https://media-exp1.licdn.com/dms/image/C4E03AQFWasY5E_cbiw/profile-displayphoto-shrink_200_200/0/1625062933054?e=1630540800&v=beta&t=lnmZbBRelVuOJLPoWlQYS4sWZmaN0TzbCZdcEVFtZqs",
  profile_url: "https://www.linkedin.com/in/robin-maclear/",
  name: "Robin Maclear",
  description: "Entrepreneur. Environmentalist. Explorer.",
  praise:
    "I have known Marc for 4 years when he was active in the M&A business and he has since introduced me to the whole new world of networking . Marc is the Master of this but more than that he has opened many doors for my company , such as two top London creative agencies to pitch for corporate events on small luxury ships and yachts. Marc is also a great motivational speaker and a lovable rogue like me!",
};

export const testimonialObj3 = {
  pic_url:
    "https://media-exp1.licdn.com/dms/image/C5603AQHuRxMI6KAeww/profile-displayphoto-shrink_100_100/0/1552585372973?e=1630540800&v=beta&t=pkgxm5H4ZzI8zgs94MKi_GpswQrIiVe1_33gCfpXkLM",
  profile_url: "https://www.linkedin.com/in/ernest-papadoyianis/",
  name: "Ernest Papadoyianis",
  description:
    "President and CEO at Advanced Integrative Medical Enterprises, Inc. and The O Med Spa",
  praise:
    "There are select people in this world that choose to serve and help others as a priority. Marc is one of those select few. He is a networking and business opportunity rainmaker with extraordinary global outreach that can assist almost anyone in business. As a U.S. business owner, I have found his services invaluable. In less than two months, he has introduced me to a global network of high quality individuals in and around my industry that would have taken years to accumulate, if ever. I would fully recommend his services to anyone interested in increasing and diversifying their network locally, nationally and globally.",
};

export const testimonialObj4 = {
  pic_url:
    "https://media-exp1.licdn.com/dms/image/C5103AQFGRdJqA_6l2g/profile-displayphoto-shrink_200_200/0/1516286647917?e=1631145600&v=beta&t=010Ou-aKH0cNenwdZc8IpJNeTgs7JOz64qhq7Vt_LEs",
  profile_url: "https://www.linkedin.com/in/ian-baker-consultancy/",
  name: "Ian Baker",
  description:
    "Serving Business Owners who aren't using the right tools in their tool shed",
  praise:
    "Marc is a natural communicator and because of this he effortlessly builds powerful networks. I have worked with Marc for just a few months, but in that time, he has introduced me to some amazing people and enabled me to start building deals and relationships. If you want to build your network, then using Marc's introducer service is a no-brainer!",
};

export const testimonialObj5 = {
  pic_url:
    "https://media-exp1.licdn.com/dms/image/C4E03AQE52SUfI8mdPA/profile-displayphoto-shrink_200_200/0/1623113101582?e=1631145600&v=beta&t=YrZUHX9dV-i2fu7acrtVbv0DOQ7oGjSHqLqpx6Dzgf8",
  profile_url:
    "https://www.linkedin.com/in/heathercmontgomery-revolutionizing-media-and-pleasure/",
  name: "Heather C Montgomery",
  description:
    "Tech Leader, Media Disruptor, Innovator and Educator in Sexual Wellness And Pleasure / Impacting Social Reform",
  praise:
    "There is so much to say about the Networking Power of Marc Jarrett! He is a man of worldwide connections and the skills to know how to keep the referrals and businesses growth coming. I have met a number of clients and amazing service providers through his network. He has tremendous follow through and a knowledge of networking tools unmatched by any man I have ever met.",
};

export const testimonialObj6 = {
  pic_url:
    "https://media-exp1.licdn.com/dms/image/C5603AQHCeeuQSkglbw/profile-displayphoto-shrink_200_200/0/1575915064506?e=1631145600&v=beta&t=rQfbNJXGrwFpAeWiz9VDmAhUZBuF1b6nteNW_Sd2cfs",
  profile_url: "https://www.linkedin.com/in/joshelledge/",
  name: "Josh Elledge",
  description: "Syndicated TV expert & newspaper columnist",
  praise:
    "It was great having Marc from Emjay Consultancy on our podcast. He brought so much wisdom and I can absolutely vouch for their purpose and values. Thank you so much for appearing. I’m eager to celebrate your founder story with our audiences! You are making the world a better place with what you’ve been creating.",
};

export const testimonialObj7 = {
  pic_url:
    "https://media-exp1.licdn.com/dms/image/C4E03AQF_siU_uJ-R8g/profile-displayphoto-shrink_200_200/0/1604079434212?e=1631145600&v=beta&t=32kZN9T3Knq0fNGV8BkAme6ETS2ZsDSKAx69DwalkNQ",
  profile_url: "https://www.linkedin.com/in/theofficialglue/",
  name: "Tollisha Joseph",
  description: "Teaching introverted Founders & CEOs to network effectively",
  praise:
    "I was given the pleasure to connect with this amazing human during a networking opportunity and I was blown away. He has an amazing way of placing people together like I’ve never seen. Through maximizing the power of human connection and the future technologies he has devised a system that is unmatched. If you haven’t had the opportunity to connect I would highly recommend that you do",
};

export const testimonialObj8 = {
  pic_url:
    "https://media-exp1.licdn.com/dms/image/C4D03AQGM8rMHy-NdFw/profile-displayphoto-shrink_800_800/0/1626700625120?e=1632960000&v=beta&t=nKQdX8eLkBUG7xTUI9m9j1Psfp1XrHeDegCi9NSpUA0",
  profile_url: "https://www.linkedin.com/in/go2market-strategist/",
  name: "Prue (Lee) Butterworth",
  description:
    "GTM Strategist with an impeccable record launching Fintech and SaaS offerings globally.",
  praise:
    "I have had the pleasure of knowing Marc since the UK's first lockdown, when like many others, I was struggling to keep up the momentum of growth within both my businesses. He is on the cutting edge of Connector, Virtual Power Networking. Marc is always available to listen and help. I have found him to be a great sounding board, and if he cannot help, he always knows someone who can!",
};

export const testimonialObj9 = {
  pic_url:
    "https://media-exp1.licdn.com/dms/image/C4E03AQF14hAaZDn5UQ/profile-displayphoto-shrink_200_200/0/1603641402177?e=1631145600&v=beta&t=EuPiCyy9E_5a64Hjd1BwUKLyPkmAUU0YJ0SdJtJtu7Y",
  profile_url:
    "https://www.linkedin.com/in/salvatore-d-urso-acma-cgma-89116517/",
  name: "Salvatore D'Urso",
  description: "Finance Lead, Consultant, Advisor",
  praise:
    "I am an admirer of Marc because he is truly unique in Virtual Networking! Marc is trustworthy and always approachable. He will always find a solution, either directly or through one of his thousands of trusted and qualified connections! I strongly recommend Marc as a friend, advisor, and virtual power networker!",
};

export const testimonialObj10 = {
  pic_url:
    "https://media-exp1.licdn.com/dms/image/C5603AQF1B6SBi6ulvA/profile-displayphoto-shrink_200_200/0/1611357160625?e=1631145600&v=beta&t=KU92PEu_lNo7DOE1xKUObezDhJTQlhL9vv7y8FUVB00",
  profile_url:
    "https://www.linkedin.com/in/sallyanderson-leadershipcoachtotheinfluencers/",
  name: "Sally Anderson",
  description: "Trusted Confidant & Advisor",
  praise:
    "In 3 decades of networking I would rate Marc Jarrett as one of the most leading edge pioneers in the field of ‘Virtual Power Networking Online! Coupled with his extraordinary networking proficiency he is a consummate connector which is a rare skill & his Rolodex is literally The Who’s Who of leading edge influencers globally! Highly recommend if you are serious about business that you book a ‘power hour’ with Marc it could literally change your life!",
};

export const testimonialObj11 = {
  pic_url:
    "https://media-exp1.licdn.com/dms/image/C5603AQFahba4ByYB_w/profile-displayphoto-shrink_200_200/0/1587835493617?e=1631145600&v=beta&t=PP0lKN_4tvhLQWsGxiI7feq8Ua1J3Hg-bQVz_o2RFsM",
  profile_url: "https://www.linkedin.com/in/lukemurfitt/",
  name: "Luke Murfitt",
  description: "Integrity Cleaning CEO",
  praise:
    "Marc Jarrett is a true gentleman and example of connecting connecting.. I highly recommend Marc for overseeing Digital communications and networking in bringing people together and enhancing business. Marc is a great person to hire.",
};

export const testimonialObj12 = {
  pic_url:
    "https://media-exp1.licdn.com/dms/image/C5103AQEjajAmG9f76A/profile-displayphoto-shrink_100_100/0/1516346454862?e=1631145600&v=beta&t=1ItM4WsPyNPh_RW-UQPBpVHhUqGbuUH4B0ZvgFf-Ht8",
  profile_url: "https://www.linkedin.com/in/hoyincheung/",
  name: "Hoyin Cheung",
  description: "Founder@Remo.co",
  praise:
    "Marc is one of the best networkers I have ever met. Diligent, smart and very good at what he does. He is an amazing virtual networker and has a knack for introducing the right people to each other. I am very amazed at his abilities and is someone worthy to have on your team!",
};

export const testimonialObj13 = {
  pic_url:
    "https://media-exp1.licdn.com/dms/image/C5603AQEHJFhraTP2sw/profile-displayphoto-shrink_100_100/0/1545284302188?e=1631145600&v=beta&t=Q-BXESNEjbL-gX-O47hxpSrBLWQtccDqD3xVIPBE7X8",
  profile_url: "https://www.linkedin.com/in/yourpartnerships/",
  name: "David Brock",
  description: "Managing Director at Your Partnerships Ltd",
  praise:
    "If you have not met Marc, you are missing out on a wonderful find. Marc will connect you to all the people and businesses you need to succeed in business. He is the most connected individual I have ever encountered. From his connections I will one minute be talking to a multi millionaire from a tech and science background and the next connection will be with a 3rd world charity looking for help to change lives of wonderful people. Marc is tireless in his efforts to help and connect people. He is open to conversation to all people and uses his great talents to help others before himself.",
};

export const testimonialObj14 = {
  pic_url:
    "https://media-exp1.licdn.com/dms/image/C4D03AQG9GKSB7PXx7A/profile-displayphoto-shrink_100_100/0/1586534868817?e=1631145600&v=beta&t=oERUtKsI8O6vKIaP-uQixrO0dWrtSRnSDB5-OIrw4_0",
  profile_url: "https://www.linkedin.com/in/mikeleearmstrong/",
  name: "Mike Armstrong",
  description: "Sales & Marketing Director / Speaker Booking Agent @Introbiz",
  praise:
    "Marc, Is a fellow Power Networker & Connector of people and businesses. He is a great contact to have and a great guy to know. Keep up the good work and I look forward to working on more projects together. I would highly recommend Marc to anyone and have already done so! All the best to you Marc, and anyone who reads this!",
};

export const testimonialObj15 = {
  pic_url:
    "https://media-exp1.licdn.com/dms/image/C4D03AQExgQsczTy1YQ/profile-displayphoto-shrink_200_200/0/1623319428399?e=1631145600&v=beta&t=dliHyzk7ROoNANSQ0BxP45-ibgULl9olNvDflCd2xHU",
  profile_url: "https://www.linkedin.com/in/kimadele-boardlevelcoach/",
  name: "Kim-adele Platts",
  description: "Board C-Suite Coach",
  praise:
    "Marc’s natural ability to network on and offline is quite simply amazing. He has a unique ability to really connect with people and use this to identify mutually beneficial connections that really impact their success. If you are looking for new avenues to grow your business or build your network, Marc is the guy to speak to.",
};
